import { render } from "./policyInfo.vue?vue&type=template&id=70acd0c7"
import script from "./policyInfo.vue?vue&type=script&lang=js"
export * from "./policyInfo.vue?vue&type=script&lang=js"

import "./policyInfo.vue?vue&type=style&index=0&id=70acd0c7&lang=css"
import "./policyInfo.vue?vue&type=style&index=1&id=70acd0c7&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__